export default "__VITE_ASSET__DjUy1bgR__"